import { Typography } from "@mui/material"


const AnomaliesMobile = () => {
  return (
     <>
     <Typography textAlign={"center"} py={4}>Coming soon... </Typography>
    </>
  )
}

export default AnomaliesMobile